import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter, OrderTypeEnum } from '../models/placeOrder';

@Injectable({
  providedIn: 'root'
})
export class PlaceOrderService {

  refreshList = new BehaviorSubject<boolean>(false);
  doFilter = new Subject<any>();
  priceListId = new Subject<any>();

  constructor(private http: HttpClient) { }

  getReservationOrderDetails(ReservationId: any) {
    return this.http.get(`${environment.apiUrl}/ReservationOrder/ResGetReservationOrderDetails?ReservationId=${ReservationId}`);
  }
  getMenuSections(data: any) {
    return this.http.post(`${environment.apiUrl}/ReservationOrder/ResGetMenuSections`, data);
  }
  getMenuItems(filter: ListFilter) {
    return this.http.post(`${environment.apiUrl}/ReservationOrder/ResGetMenuItems`, filter);
  }
  getMenuItemById(params: any) {
    return this.http.get(`${environment.apiUrl}/ReservationOrder/ResGetMenuItemById`, { params });
  }
  ResGetMenuItemsinListById(itemId: any, priceListId: number, orderType: OrderTypeEnum) {
    let params: any = { itemId, orderType }
    if (priceListId) { params.priceListId = priceListId }
    return this.http.get(`${environment.apiUrl}/ReservationOrder/ResGetMenuItemsinListById`, { params });
  }
  kitchensFilterList(ReservationId: any) {
    return this.http.get(`${environment.apiUrl}/ReservationOrder/ResKitchensFilterList?ReservationId=${ReservationId}`);
  }
  cancelOrder(ReservationId: any, orderId: number) {
    let params: any = { ReservationId, orderId }
    if (localStorage.getItem('deviceId')) {
      params.deviceId = localStorage.getItem('deviceId');
      params.deviceType = localStorage.getItem('deviceType');
    }
    return this.http.get(`${environment.apiUrl}/ReservationOrder/ResCancelOrder`, { params });
  }
  createOrder(data: any) {
    return this.http.post(`${environment.apiUrl}/ReservationOrder/ResNewOrder`, data);
  }
  editOrder(data: any) {
    return this.http.post(`${environment.apiUrl}/ReservationOrder/ResEditOrder`, data);
  }
  ResChangeItemStatus(data: any) {
    return this.http.post(`${environment.apiUrl}/ReservationOrder/ResChangeItemStatus`, data);
  }
  userCheckOrderPermission(ReservationId: any) {
    return this.http.get(`${environment.apiUrl}/ReservationOrder/ResUserCheckOrderPermission?ReservationId=${ReservationId}`);
  }
  ResPrintOrderBon(data: any) {
    return this.http.post(`${environment.apiUrl}/ReservationOrder/ResPrintOrderBon`, data);
  }
}
